import type { AuthError } from '@azure/msal-common';
import { AxiosError, AxiosResponse } from 'axios';

import { routePaths } from '@shared/router/routePaths';

const REQUEST_CANCELED = 'ERR_CANCELED';
const ONEFLIGHT_EXPORT_ERROR_CODE = 424;

const handleServerError = () => {
  return (window.location.href = routePaths.serverDown);
};

const shouldRedirectWithoutToast = (error: AxiosError) => {
  return (
    !error.response?.status ||
    (error.response.data &&
      typeof error.response.data === 'object' &&
      (('showUser' in error.response.data && error.response.data.showUser === false) ||
        !('showUser' in error.response.data)))
  );
};

export const onSuccess = (response: AxiosResponse) => {
  return response;
};

export const onError = (error: AxiosError | AuthError) => {
  const isAxiosError = error instanceof AxiosError;

  // MSAL errors (acquiring the token in the request interceptor) and other non-Axios errors are passed through
  if (!isAxiosError) {
    return Promise.reject(error);
  }

  if (isAxiosError && error.code === REQUEST_CANCELED) {
    return Promise.reject(error);
  }

  if (isAxiosError && error.status === ONEFLIGHT_EXPORT_ERROR_CODE) {
    return Promise.reject(error);
  }

  if (isAxiosError && shouldRedirectWithoutToast(error)) {
    return handleServerError();
  }

  if (isAxiosError && error.request && error.response) {
    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((_resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (!error.response || !reader.result) {
            return;
          }

          error.response.data = JSON.parse(reader.result as string);
          reject(error);
        };

        reader.onerror = () => {
          reject(error);
        };

        reader.readAsText(error.response?.data as Blob);
      });
    }
  }

  return Promise.reject(error);
};
